var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6158f4c770739c5824786572_icon-connect.svg",
    clipPath: "url(#clip0_13_336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M22.5 45.3574C34.9264 45.3574 45 35.2838 45 22.8574C45 10.431 34.9264 0.357422 22.5 0.357422C10.0736 0.357422 0 10.431 0 22.8574C0 35.2838 10.0736 45.3574 22.5 45.3574Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M27.9807 19.9728C30.0518 19.9728 31.7307 18.2939 31.7307 16.2228C31.7307 14.1517 30.0518 12.4728 27.9807 12.4728C25.9096 12.4728 24.2307 14.1517 24.2307 16.2228C24.2307 18.2939 25.9096 19.9728 27.9807 19.9728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-8",
    d: "M21.346 26.8959C22.9392 26.8959 24.2307 25.6044 24.2307 24.0113C24.2307 22.4181 22.9392 21.1266 21.346 21.1266C19.7529 21.1266 18.4614 22.4181 18.4614 24.0113C18.4614 25.6044 19.7529 26.8959 21.346 26.8959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-9",
    d: "M15.5768 32.6651C16.692 32.6651 17.5961 31.7611 17.5961 30.6459C17.5961 29.5307 16.692 28.6266 15.5768 28.6266C14.4617 28.6266 13.5576 29.5307 13.5576 30.6459C13.5576 31.7611 14.4617 32.6651 15.5768 32.6651Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0 0.357422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnect);
export default __webpack_public_path__ + "static/media/icon-connect.8daaf10f7424a9b99f391da1f13f4933.svg";
export { ForwardRef as ReactComponent };